import { useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";

const DEFAULT_PAGE_SIZE = 10;
const INITIAL_PAGE = 1;

export const usePagination = ({ totalItems, pageSize = DEFAULT_PAGE_SIZE }: { totalItems: number, pageSize?: number }) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [page, setPage] = useState(() => {
        const currentPage = searchParams.get('page');
        setSearchParams((params) => {
            const newParams = new URLSearchParams(params);
            if (!currentPage) {
                newParams.set("page", String(INITIAL_PAGE));
            }
            return newParams;
        });
        return currentPage ? Number(currentPage) : INITIAL_PAGE;
    });

    const totalPages =  Math.ceil(totalItems / pageSize);

    const changeParams = (value: number) => {
        setSearchParams((params) => {
            const newParams = new URLSearchParams(params);
            newParams.set("page", String(value));
            return newParams;
        });
    };
    const showing = useMemo(() => {
        return Math.min(page * pageSize, totalItems);
    }, [page, totalItems]);
    const isFirstPage = useMemo(() => page === INITIAL_PAGE, [page]);
    const isLastPage = useMemo(() => page === totalPages, [page, totalPages]);

    const handleGoNextPage = () => {
        setPage(actualPage => {
            const nextPage = actualPage + 1;
            changeParams(nextPage);
            return nextPage;
        });
    };
    const handleGoPreviousPage = () => {
        setPage(actualPage => {
            const prevPage = actualPage - 1;
            changeParams(prevPage);
            return prevPage;
        });
    };
    const handleGoFirstPage = () => {
        setPage(INITIAL_PAGE);
        changeParams(INITIAL_PAGE);
    };
    const handleGoLastPage = () => {
        setPage(totalPages);
        changeParams(totalPages);
    };

    return {
        page,
        showing,
        totalPages,
        limit: pageSize,
        isFirstPage,
        isLastPage,
        handleGoNextPage,
        handleGoPreviousPage,
        handleGoFirstPage,
        handleGoLastPage
    };
};